import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../select';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from '../../../utils/translations';
import { useCreateRegions } from 'widgets/selection-callout/js/hooks/hooks';
import { useSiteSettings } from 'common/react/hooks/use-site-settings';
import { setNavItem } from 'common/store/modules/competition-nav/init';

export const RegionNavItem = ({ regions }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const { setSiteSettings, settingsConfig } = useSiteSettings();

    const regionParent = nav.location.location;

    const items = useCreateRegions(regions, regionParent);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select bg-region-nav__item">
            <Select
                items={items}
                itemToString={(item) => item?.name}
                type="with-default"
                icon="location"
                initialSelectedItem={regions?.find(
                    (r) => r.id === nav.location.id
                )}
                activeItem={regions?.find((r) => r.id === nav.location.id)}
                label={getTranslation('label.filters.region')}
                onSelectedItemChange={({ selectedItem }) => {
                    const newRegion = {
                        timezone: selectedItem.timezone,
                        id: selectedItem.id,
                        name: selectedItem.name
                    };
                    dispatch(
                        setNavItem({
                            navItem: 'location',
                            value: newRegion
                        })
                    );
                    setSiteSettings({
                        [settingsConfig.region.key]: newRegion
                    });
                }}
                hideLabel
            />
        </div>
    );
};

RegionNavItem.propTypes = {
    regions: PropTypes.array,
    title: PropTypes.string
};
